/*** omit 漏检图库接口 ***/
import { http } from '@/api/http';

export default {
    /*** MissingDetection 漏检图库  ***/
    // 查询漏检图库（科室用）
    queryOmit(data) {
        return http.get('/api/MissingDetection/QueryByOrg', data);
    },
    // 查询漏检图库（后台用）
    queryOmitByBacker(data) {
        return http.get('/api/MissingDetection/QueryByBacker', data);
    },
    getOmitDetail(id) {
        return http.get(`/api/MissingDetection/${id}`);
    },
    deleteOmit(data) {
        return http.delete(`/api/MissingDetection`, data);
    },
    postOmit(data, options) {
        return http.post('/api/MissingDetection', data, options)
    },
    editOmit(id, data) {
        return http.put(`/api/MissingDetection/${id}`, data);
    },
    // 批量导入图片
    uploadGraphicZip(fileData, isBackstage) {
        return http.post(`/api/MissingDetection/UploadZip/${isBackstage}`, fileData, { contentType: 'file', timeout: 60000, noShowError: true });
    },

    /*** Graphic 漏检题  ***/
    // 漏检组卷
    postOmitPaper(data) {
        return http.post('/api/TheoryPaper/Graphic', data)
    },
    editTheoryGraphicTopic(id, data) {
        return http.put(`/api/TheoryTopic/Graphic/${id}`, data);
    },
    addTheoryGraphicInPaper(data) {
        return http.post(`/api/TheoryPaper/Graphic/Gen`, data);
    },
    // 调接口重新生成标框图片
    mergeGraphic(data) {
        return http.post(`/imageapi/Graphic/Merge`, data);
    },


    /*** MissingDetectionStatistics 漏检统计 ***/
    omitTop(data) {
        return http.get('/api/MissingDetectionStatistics/WatcherMissingTop', data);
    },
    ageOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/WatcherAgeAgeRangeTop', data);
    },
    genderOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/WatcherGenderTop', data);
    },
    gradeOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/GradeTop', data);
    },
    queryUserOmit(data) {
        return http.get('/api/MissingDetectionStatistics/Query', data);
    },

    // 个人漏检详情页-table
    queryUserOmitDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/WatcherQueryInfo/${id}`);
    },
    // 漏检时间段统计
    flightNatureTop(id) {
        return http.get(`/api/MissingDetectionStatistics/WatcherFlightNatureTop/${id}`);
    },
    // 个人能力分析
    userOmitAbility(id) {
        return http.get(`/api/MissingDetectionStatistics/WatcherCpkTop/${id}`);
    },
    // 近一周漏检图像数量
    knowledgeOmitNumber(id) {
        return http.get(`/api/MissingDetectionStatistics/WatcherLatelyTop/${id}`);
    },
    // 近一周漏检图像种类
    knowledgeOmitTop(id) {
        return http.get(`/api/MissingDetectionStatistics/WatcherKnowledgeTop/${id}`);
    },

    passengerGenderOmitTop() {
        return http.get('/api/MissingDetectionStatistics/PassengerGenderTop');
    },
    passengerAgeOmitTop() {
        return http.get('/api/MissingDetectionStatistics/PassengerAgeRangeTop');
    },
    passengerTypeOmitTop() {
        return http.get('/api/MissingDetectionStatistics/PassengerTypeTop');
    },
    passengerTransferTop() {
        return http.get('/api/MissingDetectionStatistics/TransferTop');
    },
    queryPassengerOmit(data) {
        return http.get('/api/MissingDetectionStatistics/PassengerQuery', data);
    },

    // 组织机构
    orgAgeOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/OrgAgeAgeRangeTop', data);
    },
    orgGenderOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/OrgGenderTop', data);
    },
    orgGradeOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/OrgGradeTop', data);
    },
    orgKnowledgeOmitTop(data) {
        return http.get('/api/MissingDetectionStatistics/OrgKnowledgeTop', data);
    },
    orgFlightNatureTop(data) {
        return http.get('/api/MissingDetectionStatistics/OrgFlightNatureTop', data);
    },
    queryOrgOmit(data) {
        return http.get('/api/MissingDetectionStatistics/OrgQuery', data);
    },

    // 组织机构详情页-table
    queryOrgOmitDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgQueryInfo/${id}`);
    },
    // 组织机构详情页-谁漏得最多
    OrgOmitTopDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgMissingTop/${id}`);
    },
    orgKnowledgeOmitTopDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgKnowledgeTop/${id}`);
    },
    orgFlightNatureTopDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgFlightNatureTop/${id}`);
    },
    orgAgeOmitTopDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgAgeInfoRangeTop/${id}`);
    },
    orgGenderOmitTopDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgGenderInfoTop/${id}`);
    },
    orgGradeOmitTopDetail(id) {
        return http.get(`/api/MissingDetectionStatistics/OrgGradeInfoTop/${id}`);
    },

}





